<section
  fxLayout="column"
  fxLayoutAlign=""
  class="page-container default-padding"
>
  <div>
    <a
      fxLayout="row"
      fxLayoutAlign="start center"
      class="mat-title no-margin default-ptb no-decor"
      [routerLink]="'/resume-portal/all-resumes'"
    >
      <mat-icon>arrow_back</mat-icon> {{ "return to all resumes" | titlecase }}
    </a>
  </div>
  <div fxLayoutAlign="space-between center">
    <h3>
      {{ getUserFullName() }} |
      <span class="mat-title">Creating Resume</span>
    </h3>
    <a mat-raised-button color="primary">
      <mat-icon>done</mat-icon>Complete Creating
    </a>
  </div>
  <mat-divider></mat-divider>
  <section fxLayout="row">
    <section fxFlex>
      <form class="mtb default-padding">
        <br />
        <section>
          <h2 class="bold">Personal Details</h2>
          <div>
            <div fxLayout="column">
              <mat-label>Wanted Job Tilte</mat-label>
              <mat-form-field appearance="fill">
                <input [placeholder]="'e.g Software Developer'" matInput />
              </mat-form-field>
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="space-between">
              <div fxFlex="48" fxLayout="column">
                <mat-label>Wanted Job Tilte</mat-label>
                <mat-form-field appearance="fill">
                  <input [placeholder]="'e.g Software Developer'" matInput />
                </mat-form-field>
              </div>
              <div fxFlex="48" fxLayout="column">
                <mat-label>Wanted Job Tilte</mat-label>
                <mat-form-field appearance="fill">
                  <input [placeholder]="'e.g Software Developer'" matInput />
                </mat-form-field>
              </div>
              <div fxFlex="48" fxLayout="column">
                <mat-label>Wanted Job Tilte</mat-label>
                <mat-form-field appearance="fill">
                  <input [placeholder]="'e.g Software Developer'" matInput />
                </mat-form-field>
              </div>
              <div fxFlex="48" fxLayout="column">
                <mat-label>Wanted Job Tilte</mat-label>
                <mat-form-field appearance="fill">
                  <input [placeholder]="'e.g Software Developer'" matInput />
                </mat-form-field>
              </div>
            </div>
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title
                    ><button mat-button color="primary">
                      Edit additional Details
                    </button></mat-panel-title
                  >
                </mat-expansion-panel-header>
                <div fxLayout="row wrap" fxLayoutAlign="space-between">
                  <div fxFlex="48" fxLayout="column">
                    <mat-label>Wanted Job Tilte</mat-label>
                    <mat-form-field appearance="fill">
                      <input
                        [placeholder]="'e.g Software Developer'"
                        matInput
                      />
                    </mat-form-field>
                  </div>
                  <div fxFlex="48" fxLayout="column">
                    <mat-label>Wanted Job Tilte</mat-label>
                    <mat-form-field appearance="fill">
                      <input
                        [placeholder]="'e.g Software Developer'"
                        matInput
                      />
                    </mat-form-field>
                  </div>
                  <div fxFlex="48" fxLayout="column">
                    <mat-label>Wanted Job Tilte</mat-label>
                    <mat-form-field appearance="fill">
                      <input
                        [placeholder]="'e.g Software Developer'"
                        matInput
                      />
                    </mat-form-field>
                  </div>
                  <div fxFlex="48" fxLayout="column">
                    <mat-label>Wanted Job Tilte</mat-label>
                    <mat-form-field appearance="fill">
                      <input
                        [placeholder]="'e.g Software Developer'"
                        matInput
                      />
                    </mat-form-field>
                  </div>
                  <div fxFlex="48" fxLayout="column">
                    <mat-label>Wanted Job Tilte</mat-label>
                    <mat-form-field appearance="fill">
                      <input
                        [placeholder]="'e.g Software Developer'"
                        matInput
                      />
                    </mat-form-field>
                  </div>
                  <div fxFlex="48" fxLayout="column">
                    <mat-label>Wanted Job Tilte</mat-label>
                    <mat-form-field appearance="fill">
                      <input
                        [placeholder]="'e.g Software Developer'"
                        matInput
                      />
                    </mat-form-field>
                  </div>
                  <div fxFlex="48" fxLayout="column">
                    <mat-label>Wanted Job Tilte</mat-label>
                    <mat-form-field appearance="fill">
                      <input
                        [placeholder]="'e.g Software Developer'"
                        matInput
                      />
                    </mat-form-field>
                  </div>
                  <div fxFlex="48" fxLayout="column">
                    <mat-label>Wanted Job Tilte</mat-label>
                    <mat-form-field appearance="fill">
                      <input
                        [placeholder]="'e.g Software Developer'"
                        matInput
                      />
                    </mat-form-field>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
            <div class="spacer"></div>
            <div>
              <h2>Professional Summary</h2>
              <div fxLayout="column">
                <mat-label>
                  Include 2-3 clear sentences about your overall experience
                </mat-label>
                <mat-form-field appearance="fill">
                  <mat-label>
                    e.g Passionate software developer with 8+ years of
                    experience and a tract record of ....
                  </mat-label>
                  <textarea matInput rows="10"></textarea>
                </mat-form-field>
              </div>
            </div>
            <div class="spacer"></div>
            <div>
              <h2 class="no-margin">Employment History</h2>
              <mat-label>
                Include your last 10 years of relevant experience and dates in
                this section. List your most recent position first.
              </mat-label>
              <div class="spacer"></div>
              <div fxLayout="column">
                <mat-accordion>
                  <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header>
                      <mat-panel-title> Self aware panel </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                      <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div fxFlex="48" fxLayout="column">
                          <mat-label>Job Tilte</mat-label>
                          <mat-form-field appearance="fill">
                            <input
                              [placeholder]="'e.g Software Developer'"
                              matInput
                            />
                          </mat-form-field>
                        </div>
                        <div fxFlex="48" fxLayout="column">
                          <mat-label>Employer</mat-label>
                          <mat-form-field appearance="fill">
                            <input
                              [placeholder]="'e.g Software Developer'"
                              matInput
                            />
                          </mat-form-field>
                        </div>
                      </div>
                      <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div
                          fxFlex="48"
                          fxLayout="row"
                          fxLayoutAlign="space-between"
                        >
                          <div fxFlex="49">
                            <mat-label>Start Date</mat-label>
                            <mat-form-field fxFill appearance="fill">
                              <input [placeholder]="'MM / YYYY'" matInput />
                            </mat-form-field>
                          </div>
                          <div fxFlex="49">
                            <mat-label>End Date</mat-label>
                            <mat-form-field fxFill appearance="fill">
                              <input [placeholder]="'MM / YYYY'" matInput />
                            </mat-form-field>
                          </div>
                        </div>
                        <div fxFlex="48" fxLayout="column">
                          <mat-label>City</mat-label>
                          <mat-form-field appearance="fill">
                            <input
                              [placeholder]="'e.g Software Developer'"
                              matInput
                            />
                          </mat-form-field>
                        </div>
                      </div>
                      <div>
                        <mat-form-field fxFill appearance="fill">
                          <mat-label>Descriptions</mat-label>
                          <textarea rows="10" matInput></textarea>
                        </mat-form-field>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </div>

            <div class="spacer"></div>
            <div>
              <h2 class="no-margin">Educations</h2>
              <mat-label>
                If relevant, include your most recent educational achievenebts
                and the dates here
              </mat-label>
              <div class="spacer"></div>
              <div fxLayout="column">
                <mat-accordion>
                  <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header>
                      <mat-panel-title> Self aware panel </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                      <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div fxFlex="48" fxLayout="column">
                          <mat-label>School</mat-label>
                          <mat-form-field appearance="fill">
                            <input [placeholder]="'e.g school name'" matInput />
                          </mat-form-field>
                        </div>
                        <div fxFlex="48" fxLayout="column">
                          <mat-label>Degree</mat-label>
                          <mat-form-field appearance="fill">
                            <input [placeholder]="'e.g Degree'" matInput />
                          </mat-form-field>
                        </div>
                      </div>
                      <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div
                          fxFlex="48"
                          fxLayout="row"
                          fxLayoutAlign="space-between"
                        >
                          <div fxFlex="49">
                            <mat-label>Start Date</mat-label>
                            <mat-form-field fxFill appearance="fill">
                              <input [placeholder]="'MM / YYYY'" matInput />
                            </mat-form-field>
                          </div>
                          <div fxFlex="49">
                            <mat-label>End Date</mat-label>
                            <mat-form-field fxFill appearance="fill">
                              <input [placeholder]="'MM / YYYY'" matInput />
                            </mat-form-field>
                          </div>
                        </div>
                        <div fxFlex="48" fxLayout="column">
                          <mat-label>City</mat-label>
                          <mat-form-field appearance="fill">
                            <input
                              [placeholder]="'e.g Software Developer'"
                              matInput
                            />
                          </mat-form-field>
                        </div>
                      </div>
                      <div>
                        <mat-form-field fxFill appearance="fill">
                          <mat-label>Descriptions</mat-label>
                          <textarea rows="10" matInput></textarea>
                        </mat-form-field>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </div>

            <div class="spacer"></div>
            <div>
              <h2 class="no-margin">Websites & Social Links</h2>
              <mat-label>
                You can add links to websites you want hiring managers to see!
                Perhaps it will be a link to your portfolio, LinkedIn profile,
                or personal website
              </mat-label>
              <div class="spacer"></div>
              <div fxLayout="column">
                <mat-accordion>
                  <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header>
                      <mat-panel-title> Self aware panel </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                      <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div fxFlex="48" fxLayout="column">
                          <mat-label>Label</mat-label>
                          <mat-form-field appearance="fill">
                            <input [placeholder]="'e.g school name'" matInput />
                          </mat-form-field>
                        </div>
                        <div fxFlex="48" fxLayout="column">
                          <mat-label>Link</mat-label>
                          <mat-form-field appearance="fill">
                            <input [placeholder]="'e.g Degree'" matInput />
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </div>

            <div class="spacer"></div>
            <div>
              <h2 class="no-margin">Skills</h2>
              <mat-label> List your skills </mat-label>
              <div class="spacer"></div>
              <div fxLayout="column">
                <mat-accordion>
                  <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header>
                      <mat-panel-title> Self aware panel </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                      <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div fxFlex="48" fxLayout="column">
                          <mat-label>Skill</mat-label>
                          <mat-form-field appearance="fill">
                            <input [placeholder]="'e.g school name'" matInput />
                          </mat-form-field>
                        </div>
                        <div fxFlex="48" fxLayout="column">
                          <mat-form-field appearance="fill">
                            <mat-label
                              >Select Your Level of Expertise</mat-label
                            >
                            <mat-select>
                              <mat-option
                                *ngFor="let level of skillLevels"
                                [value]="level"
                              >
                                {{ level }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </div>
          </div>
        </section>
        <section></section>
        <section></section>
        <section></section>
        <section>
          <button fxFill mat-raised-button color="primary">
            Complete Creating
          </button>
        </section>
      </form>
    </section>
    <section
      fxFlex
      fxLayoutAlign="center"
      class="resume-preview-container default-padding"
    >
      <mat-card fxFlex="90" class="no-padding mat-elevation-z5">
        <section fxFlex="65" class="default-padding">
          <div>
            <div class="normal-font no-margin bold">
              fist name and last name
            </div>
            <div class="mat-caption small-font">wanted job title</div>
          </div>
          <div class="spacer"></div>
          <div>
            <div class="meduim-font no-margin bold">Profile</div>
            <p class="small-font">Summary</p>
          </div>
          <div class="spacer"></div>
          <div>
            <div class="meduim-font no-margin bold">Employment History</div>
            <!-- <div *ngFor="let employment of props.resume.employments">
              <div class="spacer"></div>
              <div>
                <div class="small-font no-margin bold">
                  {{ employment.job_title | titlecase }},
                  {{ employment.employer | titlecase }}
                </div>
                <div class="small-font">
                  {{ employment.start_date }} - {{ employment.end_date }}
                </div>
                <p
                  class="no-margin small-font"
                  *ngFor="let description of employment.descriptions"
                >
                  - {{ description.substring(1, 100) }}
                </p>
              </div>
            </div> -->
          </div>
          <div class="spacer"></div>
          <div>
            <div class="meduim-font no-margin bold">Education</div>
            <!-- <div *ngFor="let edu of props.resume.educations">
              <div class="spacer"></div>
              <div>
                <div class="small-font no-margin bold">
                  {{ edu.degree | titlecase }}, {{ edu.school | titlecase }},
                  {{ edu.city | titlecase }}
                </div>
                <div class="small-font">
                  {{ edu.start_date }} - {{ edu.end_date }}
                </div>
                <p
                  class="no-margin small-font"
                  *ngFor="let edu_description of edu.descriptions"
                >
                  - {{ edu_description.substring(1, 100) }}
                </p>
              </div>
            </div> -->
          </div>

          <div class="spacer"></div>
          <div>
            <div class="meduim-font no-margin bold">Certificates</div>
            <!-- <div *ngFor="let cert of props.resume.certificates">
              <p class="no-margin small-font">- {{ cert.substring(1, 100) }}</p>
            </div> -->
          </div>

          <div class="spacer"></div>
          <div>
            <div class="meduim-font no-margin bold">References</div>
            <p class="no-margin small-font">Reference available upon request</p>
          </div>
        </section>

        <section fxFlex="35" class="resume-side-bg default-padding">
          <div class="mat-title no-margin">Details</div>
          <div class="small-font">phone number</div>
          <div class="small-font">email</div>
          <div fxLayout="column">
            <label>Nationality</label>
            <label class="small-font"> nationality </label>
          </div>
          <div class="spacer"></div>
          <div>
            <label>Links</label>
            <a>links goes here</a>
            <!-- <div class="small-font" *ngFor="let link of props.resume.links">
              <a class="color" [href]="link.url">{{ link.label }}</a>
            </div> -->
          </div>
          <div class="spacer"></div>
          <div>
            <label>SKILLS</label>
            <!-- <div *ngFor="let skill of props.resume.skills">
              <div class="small-font">{{ skill.skill | titlecase }}</div>
              <mat-progress-bar
                mode="determinate"
                [value]="skill.expertise"
                [color]="'light'"
              ></mat-progress-bar>
            </div> -->
          </div>
        </section>
      </mat-card>
    </section>
  </section>
</section>
